export class RequestContext {
    isImpersonating: boolean;
    userRetireeId: number;
    subjectRetireeId: number;

    public constructor(isImpersonating: boolean, userRetireeId: number, subjectRetireeId: number) {
        this.isImpersonating = isImpersonating;
        this.userRetireeId = userRetireeId;
        this.subjectRetireeId = subjectRetireeId;
    }

    public verifyUrl(url: string | undefined): string | undefined {
        if (url == undefined) {
            return url;
        }

        const modified = url.replace("{retireeId}", this.subjectRetireeId.toString());

        return modified;
    }
};
